import { ViewContract } from './view-contract';

export class ViewContractDashboard extends ViewContract {}
